module.exports = __webpack_public_path__ + "img/20200316111244297.95820ff9.png";